import type { InspectionItemDefinition } from "./types";

export const INSPECTION_ITEM_DEFINITIONS: InspectionItemDefinition[] = [
  {
    id: "item-01",
    name: "建筑类别与耐火等级",
    subitems: [
      { id: "item-01-sub-01", name: "建筑类别" },
      { id: "item-01-sub-02", name: "耐火等级" },
    ],
  },
  {
    id: "item-02",
    name: "总平面布局",
    subitems: [
      { id: "item-02-sub-01", name: "防火间距" },
      { id: "item-02-sub-02", name: "消防车道" },
      { id: "item-02-sub-03", name: "消防车登高面" },
      { id: "item-02-sub-04", name: "消防车登高操作场地" },
    ],
  },
  {
    id: "item-03",
    name: "平面布置",
    subitems: [
      { id: "item-03-sub-01", name: "消防控制室" },
      { id: "item-03-sub-02", name: "消防水泵房" },
      {
        id: "item-03-sub-03",
        name: "国家工程建设消防技术标准中有位置要求的场所（如儿童活动场所、展览厅等）",
      },
    ],
  },
  {
    id: "item-04",
    name: "建筑外墙、屋面保温和建筑外墙装饰",
    subitems: [
      { id: "item-04-sub-01", name: "建筑外墙" },
      { id: "item-04-sub-02", name: "屋面保温" },
      { id: "item-04-sub-03", name: "建筑外墙装饰" },
    ],
  },
  {
    id: "item-05",
    name: "建筑内部装修防火",
    subitems: [
      { id: "item-05-sub-01", name: "装修情况" },
      { id: "item-05-sub-02", name: "纺织织物" },
      { id: "item-05-sub-03", name: "木质材料" },
      { id: "item-05-sub-04", name: "高分子合成材料" },
      { id: "item-05-sub-05", name: "复合材料" },
      { id: "item-05-sub-06", name: "其他材料" },
      {
        id: "item-05-sub-07",
        name: "用电装置发热情况和周围材料的燃烧性能和防火隔热、散热措施",
      },
      { id: "item-05-sub-08", name: "对消防设施影响" },
      { id: "item-05-sub-09", name: "对疏散设施影响" },
    ],
  },
  {
    id: "item-06",
    name: "防火分隔",
    subitems: [
      { id: "item-06-sub-01", name: "防火分区" },
      { id: "item-06-sub-02", name: "防火墙" },
      { id: "item-06-sub-03", name: "防火门、窗" },
      { id: "item-06-sub-04", name: "竖向管道井" },
      { id: "item-06-sub-05", name: "其他有防火分隔要求的部位" },
    ],
  },
  {
    id: "item-07",
    name: "防爆",
    subitems: [
      { id: "item-07-sub-01", name: "泄压设施" },
      { id: "item-07-sub-02", name: "防静电、防积聚、防流散等措施" },
    ],
  },
  {
    id: "item-08",
    name: "安全疏散",
    subitems: [
      { id: "item-08-sub-01", name: "安全出口" },
      { id: "item-08-sub-02", name: "疏散门" },
      { id: "item-08-sub-03", name: "疏散走道" },
      { id: "item-08-sub-04", name: "避难层（间）" },
      { id: "item-08-sub-05", name: "消防应急照明和疏散指示标志" },
    ],
  },
  {
    id: "item-09",
    name: "消防电梯",
    subitems: [{ id: "item-09-sub-01", name: "消防电梯" }],
  },
  {
    id: "item-10",
    name: "消火栓系统",
    subitems: [
      { id: "item-10-sub-01", name: "供水水源" },
      { id: "item-10-sub-02", name: "消防水池" },
      { id: "item-10-sub-03", name: "消防水泵" },
      { id: "item-10-sub-04", name: "管网" },
      { id: "item-10-sub-05", name: "室内外消火栓" },
      { id: "item-10-sub-06", name: "系统功能" },
    ],
  },
  {
    id: "item-11",
    name: "建筑灭火器",
    subitems: [
      { id: "item-11-sub-01", name: "种类、数量" },
      { id: "item-11-sub-02", name: "配置、布置" },
    ],
  },
  {
    id: "item-12",
    name: "自动喷水灭火系统",
    subitems: [
      { id: "item-12-sub-01", name: "供水水源" },
      { id: "item-12-sub-02", name: "消防水池" },
      { id: "item-12-sub-03", name: "消防水泵" },
      { id: "item-12-sub-04", name: "报警阀组" },
      { id: "item-12-sub-05", name: "喷头" },
      { id: "item-12-sub-06", name: "系统功能" },
    ],
  },
  {
    id: "item-13",
    name: "火灾自动报警系统",
    subitems: [
      { id: "item-13-sub-01", name: "系统形式" },
      { id: "item-13-sub-02", name: "火灾探测器的报警功能" },
      { id: "item-13-sub-03", name: "系统功能" },
      {
        id: "item-13-sub-04",
        name: "火灾报警控制器、联动设备和消防控制室图形显示装置",
      },
    ],
  },
  {
    id: "item-14",
    name: "防烟排烟系统及通风、空调系统防火",
    subitems: [
      { id: "item-14-sub-01", name: "系统设置" },
      { id: "item-14-sub-02", name: "排烟风机" },
      { id: "item-14-sub-03", name: "管道" },
      { id: "item-14-sub-04", name: "系统功能" },
    ],
  },
  {
    id: "item-15",
    name: "消防电气",
    subitems: [
      { id: "item-15-sub-01", name: "消防电源" },
      { id: "item-15-sub-02", name: "柴油发电机房" },
      { id: "item-15-sub-03", name: "变配电房" },
      { id: "item-15-sub-04", name: "消防配电" },
      { id: "item-15-sub-05", name: "用电设施" },
    ],
  },
  {
    id: "item-16",
    name: "泡沫灭火系统",
    subitems: [
      { id: "item-16-sub-01", name: "泡沫灭火系统防护区" },
      { id: "item-16-sub-02", name: "泡沫比例混合、泡沫发生装置" },
    ],
  },
  {
    id: "item-17",
    name: "气体灭火系统",
    subitems: [{ id: "item-17-sub-01", name: "系统功能" }],
  },
];
